// extracted by mini-css-extract-plugin
module.exports = {"large":"Tag_large__1mjx6","warning":"Tag_warning__27EBa","error":"Tag_error__128-l","small":"Tag_small__3acc2","disabled":"Tag_disabled__tAFdc","primary":"Tag_primary__27O10"};